import React, { Component } from 'react';
import TagsComponent from '../../../../../../components/Tags';

/**
 * Tags screen, for showing tags list.
 *
 * @extends React.Component
 */
class Tags extends Component {
  render() {
    return (
      <TagsComponent />
    );
  }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/Tags/index.js